<div class="login_container_center" >


    <div class="flex-container">
   
    <img class="center-image" src="assets/img/guest-pass-logo.png" width="95" height="19" alt="" srcset="">
    
  </div>



  <div style="padding: 30px;">
    <div style="background-color: white; border-radius: 4px; padding: 5px;">
        <p style="text-align: end;">الشروط والأحكام:</p>
        <p style="text-align: end;">عتبر استخدام الخدمة بمثابة قبول للشروط والأحكام. يتم إيقاف المركبات على مسؤولية المالك. لا تتحمل الشركة أي مسؤولية ولا تتحمل أي مسؤولية تجاه أي ضرر / إصابة ناتجة عن عيب الفرامل، الميكانيكية / الكهربائية، أو غيرها من أعطال المعدات في السيارة. الشركة غير مسؤولة عن الأشياء الثمينة أو المتعلقات المتروكة في السيارة. يجب تقديم أي مطالبات قبل مغادرة السيارة للمنشأة.</p>
    
        <p style="margin-top: 30px;">Terms & Conditions:</p>
        <p>The use of the service is considered an acceptance of the Terms and Conditions. Vehicles are parked at the owner’s risk. The Company does not assume any liability nor hold any responsibility towards any damage/injury due to faulty brakes, mechanical/electrical, or other equipment failure in the vehicle. The Company is not responsible for valuables or belongings left in the vehicle. Any claims must be presented before the vehicle leaves the facility</p>
    
    </div>

  </div>

</div>